
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["feather feather-download-cloud",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round","class":"feather feather-download-cloud"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8 17l4 4 4-4M12 12v9"}}),_c('path',{attrs:{"d":"M20.88 18.09A5 5 0 0018 9h-1.26A8 8 0 103 16.29"}})])
          )
        }
      }
    